import styled from 'astroturf/react'
import { FixedContainer } from '@calendly/ui/components/fixed-container'
import _PageContainer from "styles-PageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=PageContainer";
import _ModalOverlay from "styles-ModalOverlay.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=ModalOverlay";
import _Modal from "styles-Modal.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=Modal";
import _ModalContent from "styles-ModalContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=ModalContent";
import _ModalTitle from "styles-ModalTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=ModalTitle";
import _ModalMessage from "styles-ModalMessage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=ModalMessage";
import _SessionPackageRow from "styles-SessionPackageRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=SessionPackageRow";
import _DetailRow from "styles-DetailRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=DetailRow";
import _DetailIcon from "styles-DetailIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=DetailIcon";
import _DetailLabel from "styles-DetailLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=DetailLabel";
import _PackageNameText from "styles-PackageNameText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=PackageNameText";
import _DetailText from "styles-DetailText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=DetailText";
import _ConfirmationText from "styles-ConfirmationText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/success/styles.js?styleId=ConfirmationText";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'

export const PageContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PageContainer",
  styles: _PageContainer
})

export const ModalOverlay = /*#__PURE__*/styled(FixedContainer, null, {
  displayName: "ModalOverlay",
  styles: _ModalOverlay
})

export const Modal = /*#__PURE__*/styled("div", null, {
  displayName: "Modal",
  styles: _Modal
})

export const ModalContent = /*#__PURE__*/styled("div", null, {
  displayName: "ModalContent",
  styles: _ModalContent
})

export const ModalTitle = /*#__PURE__*/styled("h1", null, {
  displayName: "ModalTitle",
  styles: _ModalTitle
})

export const ModalMessage = /*#__PURE__*/styled("p", null, {
  displayName: "ModalMessage",
  styles: _ModalMessage
})

export const SessionPackageRow = /*#__PURE__*/styled("div", null, {
  displayName: "SessionPackageRow",
  styles: _SessionPackageRow
})

export const DetailRow = /*#__PURE__*/styled("div", null, {
  displayName: "DetailRow",
  styles: _DetailRow
})

export const DetailIcon = /*#__PURE__*/styled("div", null, {
  displayName: "DetailIcon",
  styles: _DetailIcon
})

export const DetailLabel = /*#__PURE__*/styled("div", null, {
  displayName: "DetailLabel",
  styles: _DetailLabel
})

export const PackageNameText = /*#__PURE__*/styled("div", null, {
  displayName: "PackageNameText",
  styles: _PackageNameText
})

export const DetailText = /*#__PURE__*/styled("div", null, {
  displayName: "DetailText",
  styles: _DetailText
})

export const ConfirmationText = /*#__PURE__*/styled("p", null, {
  displayName: "ConfirmationText",
  styles: _ConfirmationText
})
